module.exports = __webpack_public_path__ + "components/home-header/static/header-4--medium@2x-d844ec9feeaddb3abeb513c10a404405.jpg";